import { PageTitle } from '../../components/title/PageTitle';

export default function MemberBenefit2() {
  return (
    <div className="main_wrap">
      <div className="contents_wrap">
        <PageTitle>코인 획득법</PageTitle>
      </div>
    </div>
  );
}
